// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1lJwr","title":"Images45_title__wJtyO","images":"Images45_images__zj1U4"};